import { BodyText, Card, Flex, Heading } from '@utilitywarehouse/hearth-react';
import {
  LaunchMediumIcon,
  MeterMediumIcon,
  SimMediumIcon,
} from '@utilitywarehouse/hearth-react-icons';
import clsx from 'clsx';
import { ReactNode } from 'react';

import {
  SlideHeading,
  Terms,
} from '@components/PresentationRebrand/ContentSlide/slides/shared';
import { useBreakpoints } from '@utils/useBreakpoints.ts';

import './styles.scss';
import photo from '/Presentation/Desktop/go-unlimited.png';

type Feature = {
  icon: ReactNode;
  title: string;
  text?: string;
};

const FEATURES: Feature[] = [
  {
    icon: <MeterMediumIcon />,
    title: 'Unlimited data',
    text: 'For endless streaming, chatting and sharing.',
  },
  {
    icon: <LaunchMediumIcon />,
    title: 'Speedy and reliable 5G',
  },
  {
    icon: <SimMediumIcon />,
    title: 'Up to three extra SIMs FREE for three months',
  },
];

export const GoUnlimited = () => {
  const { breakpointsDown } = useBreakpoints();
  const isMobile = breakpointsDown.sm;
  const isTablet = breakpointsDown.md && !isMobile;
  const isDesktop = !breakpointsDown.md;

  const photoCard = (
    <Card
      variant="emphasis"
      shadowColor="functional"
      colorScheme="neutralStrong"
      className="go-unlimited__photo"
      paddingNone
    >
      <div className="go-unlimited__photo-frame">
        <img
          src={photo}
          alt="Two people smiling at a phone"
          className="go-unlimited__photo-image"
        />
      </div>
    </Card>
  );

  return (
    <Flex direction="column" gap="200" className="go-unlimited">
      <div className="go-unlimited__content">
        <div className="go-unlimited__main">
          <div className="go-unlimited__intro">
            <SlideHeading>
              Say hi to <br />
              <span className="go-unlimited__accent">Go Unlimited</span>
            </SlideHeading>
            <Heading size="md" asChild>
              <p>Our best ever SIM-only deal</p>
            </Heading>
          </div>

          <div className="go-unlimited__offer">
            {isTablet && photoCard}
            <div className="go-unlimited__details">
              <Heading size="xl" asChild>
                <p>£13 a month</p>
              </Heading>
              <ul className="go-unlimited__features">
                {FEATURES.map(({ icon, title, text }) => (
                  <li
                    key={title}
                    className={clsx(
                      'go-unlimited__feature',
                      text && 'go-unlimited__feature--top'
                    )}
                  >
                    <span className="go-unlimited__icon">{icon}</span>
                    <div className="go-unlimited__feature-text">
                      <Heading size="md" asChild>
                        <p>{title}</p>
                      </Heading>
                      {text && <BodyText size="lg">{text}</BodyText>}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <Card variant="emphasis" colorScheme="neutralStrong">
            <div className="go-unlimited__essential">
              <Heading size="md" asChild>
                <p>
                  Or keep it Essential -{' '}
                  <span className="go-unlimited__accent">Go Essential</span> -
                  £6 a month
                </p>
              </Heading>
              <ul className="go-unlimited__essential-list">
                <li>
                  <BodyText size="md">
                    <strong>10GB data</strong> - Great for everyday browsing,
                    messaging and staying connected.
                  </BodyText>
                </li>
                <li>
                  <BodyText size="md">Speedy and reliable 5G</BodyText>
                </li>
              </ul>
            </div>
          </Card>
        </div>

        {isDesktop && photoCard}
      </div>

      <Terms />
    </Flex>
  );
};
